export default "__VITE_ASSET__CFCDmL5F__"